export default {"src":"/_next/static/media/sys.805ec8b0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};